module.exports = __webpack_public_path__ + "img/lagoon-systems-text.69f44877.svg";